export interface PrivacySection {
  id: string;
  titleKey: string;
  paragraphKeys: string[];
}

/** tilliX Privacy Policy — sourced from tillisoftware.com/privacy-policy (January 2025). */
export const tilliPrivacySections: PrivacySection[] = [
  {
    id: "introduction",
    titleKey: "privacy.sections.introduction.title",
    paragraphKeys: ["privacy.sections.introduction.p1"],
  },
  {
    id: "information-collection",
    titleKey: "privacy.sections.informationCollection.title",
    paragraphKeys: [
      "privacy.sections.informationCollection.p1",
      "privacy.sections.informationCollection.p2",
      "privacy.sections.informationCollection.p3",
    ],
  },
  {
    id: "information-usage",
    titleKey: "privacy.sections.informationUsage.title",
    paragraphKeys: ["privacy.sections.informationUsage.p1"],
  },
  {
    id: "information-sharing",
    titleKey: "privacy.sections.informationSharing.title",
    paragraphKeys: ["privacy.sections.informationSharing.p1"],
  },
  {
    id: "data-security",
    titleKey: "privacy.sections.dataSecurity.title",
    paragraphKeys: [
      "privacy.sections.dataSecurity.p1",
      "privacy.sections.dataSecurity.p2",
    ],
  },
  {
    id: "data-retention",
    titleKey: "privacy.sections.dataRetention.title",
    paragraphKeys: ["privacy.sections.dataRetention.p1"],
  },
  {
    id: "user-rights",
    titleKey: "privacy.sections.userRights.title",
    paragraphKeys: [
      "privacy.sections.userRights.p1",
      "privacy.sections.userRights.p2",
      "privacy.sections.userRights.p3",
    ],
  },
  {
    id: "cookies-and-tracking",
    titleKey: "privacy.sections.cookiesAndTracking.title",
    paragraphKeys: [
      "privacy.sections.cookiesAndTracking.p1",
      "privacy.sections.cookiesAndTracking.p2",
    ],
  },
  {
    id: "childrens-privacy",
    titleKey: "privacy.sections.childrensPrivacy.title",
    paragraphKeys: ["privacy.sections.childrensPrivacy.p1"],
  },
  {
    id: "international-data-transfers",
    titleKey: "privacy.sections.internationalDataTransfers.title",
    paragraphKeys: ["privacy.sections.internationalDataTransfers.p1"],
  },
  {
    id: "policy-changes",
    titleKey: "privacy.sections.policyChanges.title",
    paragraphKeys: ["privacy.sections.policyChanges.p1"],
  },
  {
    id: "contact-information",
    titleKey: "privacy.sections.contactInformation.title",
    paragraphKeys: [
      "privacy.sections.contactInformation.p1",
      "privacy.sections.contactInformation.p2",
      "privacy.sections.contactInformation.p3",
      "privacy.sections.contactInformation.p4",
      "privacy.sections.contactInformation.p5",
    ],
  },
];
